module.exports = __webpack_public_path__ + "static/367117_3_0-5b1326b66eb907e01036502c2002d526.woff2";